
import {
  Component,
  Prop,
  Mixins,
  Emit,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Button,
  Upload,
  Radio,
} from 'element-ui';
import { ISetting } from '@/types/set.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Select,
    Option,
    Button,
    Upload,
    Radio,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '添加活动海报',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  @Prop({
    required: false,
  }) typeList!: any;

  @Prop({
    required: false,
  }) showDiffi!: boolean;

  private initType: string = '';

  private status: any = [{ label: '是', value: 0 }, { label: '否', value: 1 }];

  private fileListImg: any = [];

  // private csrSource: any = [];

  mounted() {   
     if (this.title.includes('编辑')) {
      this.form = {
        pid: this.oldForm.pid,
        title: this.oldForm.title,
        from: String(this.oldForm.fromTo),
      };
      if (this.oldForm.files) this.fileListImg = [{ url: this.oldForm.iconPath }];
    }
  }

  /**
   * @author lianguongmou
   * @desc 图片上传前事件
    */
  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      // this.fileListImg = [{ url: e.target.result }];
      if (Array.isArray(this.fileListImg)) {
        this.fileListImg.push({ url: e.target.result });
      } else {
        this.fileListImg = [{ url: e.target.result }];
      }
    };
    this.form.files = file;
    if (Array.isArray(this.form.files)) {
      this.form.files.push(file as File);
    } else {
      this.form.files = [file as File];
    }
    return false;
  }

  /**
   * @author liangyongmou
   * @desc 主图片删除事件
   * @params { any } file 文件
   */
  handleBeforeRemove(file: any) {
    if (file.status === 'success') this.form.stepImage = '';
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        const data = new FormData();
        Object.keys(this.form).forEach((key) => {
           data.append(key, this.form[key]);
        });
        if (title.includes('编辑')) {
          api.editActivityBanner(data).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addActivityBanner(data).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }

  selectType(addType: string) {
    this.initType = this.form.initType;
    this.$emit('bindGetType', addType);
  }
}
